import React from "react";

export default function Terms() {
	return (
		<>
			<div>
				<div class="text-area">
					<h1 className="text-4xl font-bold text-gray-700 mt-10">
						Terms & Conditions
					</h1>
					<div className="py-10 sm:px-20 px-10">
						<p align="justify">
							Tathagat Tutorials Private Limited respects your privacy. We
							understand clearly that you and your personal information is one
							of our most important assets. We store and process your
							information (as defined under the Information Technology Act,
							2000), if any, on computers that may be protected by physical as
							well as reasonable technological security measures. You are
							advised to please read the privacy policy carefully. By accessing
							the services provided by Tathagat Tutorials Private Limited you
							agree to the collection and use of your data by Tathagat Tutorials
							Private Limited in the manner provided in this privacy policy. We
							collect the following personally identifiable information about:
							<br />
							Name including first and last name
							<br />
							Email address
							<br />
							Mobile phone number and contact details
							<br />
							Postal code
							<br />
							Other information as per our registration process
							<br />
							<br />
							We will not use your financial information for any purpose other
							than to complete a transaction with you. We do not rent, sell or
							share your personal information and we will not disclose any of
							your personally identifiable information to third parties unless:
							<br />
							<br />
							To help investigate, prevent or take action regarding unlawful and
							illegal activities, suspected fraud, potential threat to the
							safety or security of any person, violations of Gyan Bindu Academy
							Private Limited’s terms of use or to defend against legal claims
							or in case of special circumstances such as compliance with court
							orders, requests or order, notices from legal authorities or law
							enforcement agencies requiring such disclosure.
							<br />
							<br />
							Note: Our privacy policy is subject to change at any time without
							notice. To make sure you are aware of any changes, please review
							this policy periodically.
							<br />
							<br />
							<strong>Trademark Notice</strong>
							<br />
							The logo and image of Tathagat Tutorials Private Limited on the
							home page of the websites, mobile sites or applications and other
							pages and as used in the communication to the user is registered
							by Tathagat Tutorials Private Limited and cannot be used or
							communicated or distributed without the specific and written
							permission of Tathagat Tutorials Private Limited.
							<br />
							<br />
							<strong>Copyright</strong>
							<br />
							Please read this license agreement carefully before using this
							site. Any software, content or other material that is on this site
							is the copyrighted work of Tathagat Tutorials Private Limited. Use
							of the content is governed by the terms of this license agreement.
							If you do not agree to these terms, please do not use this site.
							By using this site, you signify your acceptance of these terms.
							<br />
							<br />
							This site is owned and operated by Tathagat Tutorials Private
							Limited. No content from this site may be copied, reproduced,
							republished, transmitted, or distributed in any way, except that
							you may temporarily download one copy of the content on any single
							computer or print one or more copies of the content for your
							personal, non-commercial use only, provided you keep intact all
							copyright, trademark and other proprietary notices. Modification
							of the content contained on this site or use of the content for
							any other purpose is prohibited and constitutes a violation of the
							copyright and other proprietary rights of Tathagat Tutorials
							Private Limited.
							<br />
							<br />
							<strong>Shipping policy</strong>
							<br />
							We are committed to delivering your order accurately, in good
							condition, and always on time promised by us in our website.
							<br />
							We offer FREE Shipping (specified on the study materials) for
							selected locations ordered through tathagat.co.in
							<br />
							Each order may be shipped only to a single destination address
							specified at the time of payment for that order.
							<br />
							<br />
							We make our best efforts to ship each item in your order within
							4-5 working days of the order. However, in certain remote
							locations, we may take longer, up to 10-15 days, to ship the
							order.
							<br />
							<br />
							To ensure that your order reaches you in a short time and in good
							condition, we only ship through reputed courier agencies or post
							office.
							<br />
							If you believe that the product is not in good condition, or if
							the packaging is tampered with or damaged, before accepting
							delivery of the goods, please refuse to take delivery of the
							package, and call our Customer care 011 4358 0693 or mail us,
							mentioning your order reference number. We shall make our best
							efforts to ensure that a replacement delivery is made to you at
							the earliest.
							<br />
							<br />
							In the event that a non-delivery occurs on account of a mistake by
							you (i.e. wrong name or address) any extra cost incurred by
							Tathagat Tutorials for re-delivery shall be claimed from the User
							placing the order.
							<br />
							<br />
							Before delivering your order to you, we may request you to provide
							supporting documents (including but not limited to Govt. issued ID
							and address proof) to establish the ownership of the payment
							instrument used by you for your purchase. This is done in the
							interest of providing a safe online shopping environment to Our
							Users.
							<br />
							<br />
							<strong>Order</strong>
							<br />
							Ordering at Tathagat Tutorials Private Limited is easy. Placing
							your first order at Tathagat Tutorials Private Limited just select
							the items you want to shop for, enter your shipping address, and
							payment. If you need any assistance give us a call. Once your
							order is successfully placed, you will receive a confirmation over
							email from Tathagat Tutorials Private Limited. This mail will have
							all the details related to your order. Any request for
							cancellation of orders once duly placed on the site, shall not be
							entertained.
							<br />
							<br />
							<strong>Payment</strong>
							<br />
							Your online transaction on Tathagat Tutorials Private Limited is
							secure with the highest levels of transaction security currently
							available on the Internet. All credit card and debit card payments
							on Tathagat Tutorials Private Limited are processed through secure
							and trusted payment gateways managed by leading banks. Banks now
							use the 3D secure password service for online transactions,
							providing an additional layer of security through identity
							verification.
							<br />
							In a credit/debit card transaction, you must use a credit /debit
							card that is issued in the name of the User. Tathagat Tutorials
							Private Limited will not be liable for any credit/debit card fraud
							because of the card being used fraudulently. The liability to use
							a credit/debit card or a net banking transaction fraudulently will
							be on the User and the onus to ‘prove otherwise’ shall be
							exclusively on the User. Tathagat Tutorials Private Limited
							reserves the right to cancel orders for the product at their sole
							discretion for any reason which can include but is not be limited
							to, the product being out of stock, or for any other reason
							without intimation to the User.
							<br />
							<br />
							While availing any of the payment method/s available on the
							website, we will not be responsible or assume any liability,
							whatsoever in respect of any loss or damage arising directly or
							indirectly to You due to:
							<br />
							Lack of authorization for any transaction/s, or
							<br />
							Exceeding the preset limit mutually agreed by You and between
							Bank/s, or
							<br />
							Any payment issues arising out of the transaction, or
							<br />
							Decline of transaction for any other reason/s
							<br />
							<br />
							All payments made against the purchases/services on website by you
							shall be compulsorily in Indian Rupees acceptable in the Republic
							of India. <br />
							Website will not facilitate transaction with respect to any other
							form of currency with respect to the purchases made on Website.
							<br />
							<br />
							<strong>Refund Policy</strong>
							<br />
							We provide two course trial alternatives to students who are
							interested in enrolling with TathaGat. A student may sign up for a
							15-day course trial OR a demo class. A student may take the 15-day
							trial course, once he/she has enrolled by paying the fee as per
							the offered plan. The 15-day trial period is subject to the fee
							refund policy. If, over the course of 15- day trial—during which
							there will be at least 4–5 classes—a student experiences any
							problems, or, for any reason, decides against continuing with the
							enrolment, an unconditional fee refund will be provided. The
							students who sign up for the demo class will not be entitled to a
							fee refund. Also, any student who has been offered a fee rebate
							for any reasons shall not be eligible for any refund.
							<br />
							<br />
							<strong>Electronic Communication</strong>
							<br />
							When you visit Tathagat Tutorials Private Limited or send e-mails
							to us or give us your feedback, you are communicating with us
							electronically. You consent to receive communications from us
							electronically. We will communicate with you by e-mail or by
							posting notices on the website of Tathagat Tutorials Private
							Limited. You agree that all agreements, notices, disclosures and
							other communications that we provide to you electronically satisfy
							any legal requirement that such communications be in writing.
							<br />
							<br />
							<strong>
								Reviews, Comments, Communications, and other Contents
							</strong>
							<br />
							Visitors may post reviews, comments, and other content; and submit
							suggestions, ideas, comments, questions, or other information, so
							long as the content is not illegal, obscene, threatening,
							defamatory, invasive of privacy, infringing on intellectual
							property rights, or otherwise injurious to third parties or
							objectionable and does not consist of or contain software viruses,
							political campaigning, commercial solicitation, chain letters,
							mass mailings, or any form of “spam.” You may not use a false
							e-mail address, impersonate any person or entity, or otherwise
							mislead as to the origin of a card or other content. Tathagat
							Tutorials Private Limited reserves the right (but not the
							obligation) to remove or edit such content, but does not regularly
							review posted content.
							<br />
							<br />
							<strong>Terms of use</strong>
							<br />
							The domain name tathagat.co.in (hereinafter referred to as
							“Website”) is owned by Tathagat Tutorials Private Limited a
							company incorporated under the Companies Act, 1956 with its
							registered office at Near, 28-A/11A, (106, 1st Floor, New Delhi
							House, Barakhamba Road, New Delhi - 110001, India. By visiting
							this Website, you agree to be bound by the terms and conditions of
							this Privacy Policy. If you do not agree please do not use or
							access our Website.
							<br />
							<br />
							<strong>Applicable law</strong>
							<br />
							Terms of Use shall be governed by and interpreted and construed in
							accordance with the laws of India. The place of jurisdiction shall
							be exclusively in Delhi. Tathagat Tutorials Private Limited
							reserves the right to make changes to the terms, conditions and
							disclaimers at any time and without information to the
							customers/users of the services/of Tathagat Tutorials Private
							Limited. Users are advised to regularly check for any amendments
							or updates to the terms and conditions contained herein.
							<br />
							<br />
							Unless otherwise specified, the material on the Website is
							presented solely for the purpose of sale in India. Tathagat
							Tutorials Private Limited makes no representation that materials
							in the Website are appropriate or available for use in other
							locations/Countries other than India. Those who choose to access
							this site from other locations/Countries other than India do so on
							their own initiative and Tathagat Tutorials Private Limited is not
							responsible for supply of products/refund for the products ordered
							from other locations/Countries other than India, compliance with
							local laws, if and to the extent local laws are applicable.
						</p>
					</div>
				</div>
			</div>
		</>
	);
}
